import React, { useState } from "react";

interface CreateListModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCreate?: (name: string) => void;
}

export default function CreateListModal({ isOpen, onClose, onCreate }: CreateListModalProps) {
    const [name, setName] = useState("");

    const handleSubmit = () => {
        if (!name.trim()) return;
        onCreate?.(name.trim());
        setName("");
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded shadow-md w-full max-w-sm">
                <h2 className="text-lg font-semibold mb-4 text-center">Új hírlevéllista létrehozása</h2>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Lista neve"
                    className="w-full px-3 py-2 border rounded mb-4"
                />
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                    >
                        Mégse
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-brown text-white rounded hover:bg-dark-brown"
                    >
                        Létrehozás
                    </button>
                </div>
            </div>
        </div>
    );
}
